var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Drawer as DrawerMui, Stack } from '@mui/material';
import { CardTitle } from './CardTitle';
import { CloseIcon } from './Icons';
import { IconButton } from './IconButton';
export var Drawer = function (_a) {
    var children = _a.children, onClose = _a.onClose, title = _a.title, startIcon = _a.startIcon, props = __rest(_a, ["children", "onClose", "title", "startIcon"]);
    return (_jsxs(DrawerMui, __assign({ open: true, anchor: "right", onClose: onClose }, props, { children: [_jsxs(Stack, __assign({ direction: "row", justifyContent: "space-between" }, { children: [_jsx(CardTitle, { title: "Utilisateurs \"".concat(title, "\""), startIcon: startIcon, color: "neutre", withFileAriane: true }), _jsx(IconButton, __assign({ tooltip: "Fermer", onClick: onClose }, { children: _jsx(CloseIcon, {}) }))] })), _jsx(Stack, __assign({ p: 1 }, { children: children }))] })));
};
//# sourceMappingURL=Drawer.js.map